import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { P2P_DETAIL_TAB_HOLDERS, type P2pDetailTabId } from '@/config/p2p'
import type { RootState } from '@/store/store'
import type { P2pOptionType } from '@/types/p2p'

interface P2pState {
	selectedOptionId: string | null
	activeTab: P2pDetailTabId
	buySide: P2pOptionType
	buyAmount: string
	favoriteIds: string[]
}

const initialState: P2pState = {
	selectedOptionId: null,
	activeTab: P2P_DETAIL_TAB_HOLDERS,
	buySide: 'yes',
	buyAmount: '10',
	favoriteIds: [],
}

const p2pSlice = createSlice({
	name: 'p2p',
	initialState,
	reducers: {
		resetP2pDetail(state) {
			state.selectedOptionId = null
			state.activeTab = P2P_DETAIL_TAB_HOLDERS
			state.buySide = 'yes'
			state.buyAmount = '10'
		},
		setSelectedP2pOption(state, action: PayloadAction<string>) {
			state.selectedOptionId = action.payload
		},
		setP2pMarketDetailTab(state, action: PayloadAction<P2pDetailTabId>) {
			state.activeTab = action.payload
		},
		setP2pOptionType(state, action: PayloadAction<P2pOptionType>) {
			state.buySide = action.payload
		},
		setP2pBuyAmount(state, action: PayloadAction<string>) {
			state.buyAmount = action.payload
		},
		selectP2pOptionWithSide(state, action: PayloadAction<{ optionId: string; side: P2pOptionType }>) {
			state.selectedOptionId = action.payload.optionId
			state.buySide = action.payload.side
		},
		toggleP2pFavorite(state, action: PayloadAction<string>) {
			const marketId = action.payload
			const index = state.favoriteIds.indexOf(marketId)

			if (index >= 0) {
				state.favoriteIds.splice(index, 1)
				return
			}

			state.favoriteIds.push(marketId)
		},
	},
})

export const { resetP2pDetail, setSelectedP2pOption, setP2pMarketDetailTab, setP2pOptionType, setP2pBuyAmount, selectP2pOptionWithSide, toggleP2pFavorite } = p2pSlice.actions

export const selectSelectedP2pOptionId = (state: RootState) => state.p2p.selectedOptionId
export const selectP2pActiveTab = (state: RootState) => state.p2p.activeTab
export const selectP2pOptionType = (state: RootState) => state.p2p.buySide
export const selectP2pBuyAmount = (state: RootState) => state.p2p.buyAmount
export const selectIsP2pFavorite = (marketId: string) => (state: RootState) => state.p2p.favoriteIds.includes(marketId)

export default p2pSlice.reducer
